"use client";

import { c as _c } from "react/compiler-runtime";
import { useT } from "@/lib/i18n";
export default function RunFileHelp() {
  const $ = _c(9);
  const t = useT();
  let t0;
  if ($[0] !== t) {
    t0 = t("Your .run files live here:");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className="text-[var(--text-secondary)]">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><strong className="text-[var(--text-secondary)] block sm:inline">Windows</strong><code className="block sm:inline sm:ml-1 mt-0.5 sm:mt-0 bg-[var(--bg-primary)] px-1.5 py-0.5 rounded break-all">{"%AppData%/SlayTheSpire2/steam/<steamid>/profile1/saves/history"}</code></div>;
    t3 = <div><strong className="text-[var(--text-secondary)] block sm:inline">macOS</strong><code className="block sm:inline sm:ml-1 mt-0.5 sm:mt-0 bg-[var(--bg-primary)] px-1.5 py-0.5 rounded break-all">{"~/Library/Application Support/SlayTheSpire2/steam/<steamid>/profile1/saves/history"}</code></div>;
    t4 = <div><strong className="text-[var(--text-secondary)] block sm:inline">Linux / Steam Deck</strong><code className="block sm:inline sm:ml-1 mt-0.5 sm:mt-0 bg-[var(--bg-primary)] px-1.5 py-0.5 rounded break-all">{"~/.local/share/SlayTheSpire2/steam/<steamid>/profile1/saves/history"}</code></div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1) {
    t5 = <div className="text-left text-xs text-[var(--text-muted)]" onClick={_temp}><div className="space-y-1.5">{t1}{t2}{t3}{t4}</div></div>;
    $[7] = t1;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp(e) {
  return e.stopPropagation();
}